import { render, staticRenderFns } from "./AdminBot.vue?vue&type=template&id=4721d27c&"
import script from "./AdminBot.vue?vue&type=script&lang=js&"
export * from "./AdminBot.vue?vue&type=script&lang=js&"
import style0 from "./AdminBot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports